/*
 * Buy box: when most sizes carry a "son 1 / son 2" note, the notes stop meaning anything.
 * Three or more low-stock tiles collapse into one honest line under the size grid.
 * "Tükendi" notes stay. Roll back: remove the hs3-buybox script tag in sections/main-product.liquid.
 */
(function () {
  function tidy() {
    var grid = document.querySelector('.hs-size-grid');
    if (!grid) return;
    var line = grid.parentNode.querySelector('.hs3-lowline');
    var low = grid.querySelectorAll('.hs3-tile__note.is-low').length;
    var open = grid.querySelectorAll('input[type=radio]:not(.disabled)').length;
    var collapse = low >= 3;
    grid.classList.toggle('is-lowcollapsed', collapse);
    if (!collapse) { if (line) line.remove(); return; }
    var text = low >= open ? 'Tüm bedenlerde son 1–2 ürün kaldı' : 'Çoğu bedende son 1–2 ürün kaldı';
    if (!line) {
      line = document.createElement('p');
      line.className = 'hs3-lowline';
      grid.insertAdjacentElement('afterend', line);
    }
    if (line.textContent !== text) line.textContent = text;
  }
  var timer;
  new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(tidy, 80); })
    .observe(document.documentElement, { childList: true, subtree: true });
  tidy();
})();
